import { getAuthHeaders } from './authToken';

const API_BASE = process.env.REACT_APP_API_URL;

// No request body, so no Content-Type. Carries the signed-in user's Zitadel access token.
const getHeaders = () => getAuthHeaders(false);

/**
 * Get Slack channels that were created via the SlackChannelsController API
 * (as opposed to hand-entered slack channel configurations).
 * @returns {Promise<Array<{id: number, slackChannelId: string, name: string, isActive: boolean, createdAt: string, updatedAt: string|null}>>}
 */
export const getApiCreatedSlackChannels = async () => {
  const response = await fetch(`${API_BASE}/api/slack-channels`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch API-created Slack channels');
  }

  return response.json();
};
